export function isRichTextLeafVariant(
  mark: RichTextVariant,
): mark is RichTextLeafVariant {
  return ['bold', 'italic', 'underline', 'strikethrough'].includes(mark);
}
